export const isDev = process.env.NODE_ENV === 'development';
export const isProd = process.env.NODE_ENV === 'production';

export const siteUrl = isDev
  ? 'http://localhost:8000'
  : process.env.GATSBY_SITE_URL || 'https://earth.fm';

export const wpGraphqlUrl = isDev
  ? 'http://headlesswp.earthfm.local/graphql'
  : process.env.GATSBY_WPGRAPHQL_URL || 'https://wp.earth.fm/graphql';

export const productionSiteUrl = 'https://earth.fm';

export const frontendHost = new URL(siteUrl).host;
export const wpHost = new URL(wpGraphqlUrl).host;
export const wpUrl = wpGraphqlUrl.replace('/graphql', '');

// The shop is no longer part of this site — the Shopify store was closed and replaced by a
// Fourthwall storefront. Old /shop/ and /cart/ URLs are redirected here in src/create-redirects.ts.
export const fourthwallShopUrl = 'https://shop.earth.fm/';

export const isLiveEnv = isProd && frontendHost === 'earth.fm';

export const typesenseCollectionName = process.env.GATSBY_TYPESENSE_COLLECTION_NAME || 'earth_fm';
export const typesenseSearchConfig = {
  host: process.env.GATSBY_TYPESENSE_HOST || '',
  apiKey: process.env.GATSBY_TYPESENSE_SEARCH_API_KEY || '',
};

export const pages = {
  home: '/',
  webapp: '/web/',
  search: '/search/',
  signIn: '/signin/',
  signUp: '/signup/',
  signInWithEmail: '/sign-in-with-email/',
  checkSignInEmail: '/check-sign-in-email/',
  becomeAMember: '/become-a-member/',
  memberProfileSetup: '/member-profile-setup/',
  memberLibrary: '/member-library/',
  memberProfileSettings: '/member-settings/profile/',
  memberAccountSettings: '/member-settings/account/',
  memberMembershipSettings: '/member-settings/membership/',
  memberPrivacySettings: '/member-settings/privacy/',
  memberArtistSettings: '/member-settings/artist/',
  createPlaylist: '/create-playlist/',
  memberPlaylistBase: '/member-playlist/',
  about: '/about-us/',
  contact: '/contact-us/',
  privacyPolicy: 'https://hub.goadopt.io/document/1e46efc0-a250-4e8a-ab46-dff0160bb4f1',
  newsletter: '/newsletter-subscription/',
  sitemap: '/sitemap/',
  blog: '/blog/',
  glossary: '/glossary/',
  playlists: '/playlists/',
  ambassador: '/ambassadors/',
  ambassadorPlaylistCategory: '/earth-fm-ambassadors/',
  podcast: '/podcast/',
  recordings: '/recordings/',
  shop: '/shop/',
  donationCompleted: '/donation-completed/',
  artists: '/artists/',
  scholarship: '/scholarship/',
  desktopAppSignIn: '/desktop-app-sign-in',
  giftCard: '/gift-card/',
  thankYou: '/thank-you/',
  app: '/app/',
  externalCookieUrl: 'https://hub.goadopt.io/document/55532be7-9424-46af-af20-905360c28f37',
  impactReports: '/impact-reports/',
  grants: '/field-recording-grant/',
  quietPlacesFinder: '/the-quietest-places-in-the-worlds-loudest-cities/',
  embed: '/embed/',
  desktopApp: '/earth-fm-for-desktop/',
  soundMap: '/nature-soundmap/',
  submit: '/submit/',
  invite: '/invite/:inviteCode',
  businessInquiry: '/business-inquiry/',
  playlistCategories: '/playlist-categories/',
};

export const customAppPageUris = [
  '/rain-sounds-app/',
  '/ocean-sounds-app/',
  '/baby-sleep-sounds-app/',
  '/sleep-sounds-app/',
  '/forest-sounds-app/',
  '/thunderstorm-sounds-app/',
];

export const apiUrls = {
  newsletterSubscription: '/api/newsletter-subscription-handler',
  trendingRecordings: '/api/trending-recordings',
};

export const earthFmPlaylistOwner = {
  id: 'earth-fm',
  name: 'Earth.fm',
};

export const nonLoggedInUserTimeLimit = 20 * 60; // 20 minutes in seconds
export const loggedInNonMemberTimeLimit = 30 * 60; // 30 minutes in seconds
export const allRecordingsFree = false; // set to true to temporarily treat all recordings as free
// Using a non-guessable key here so that a user can't easily bypass the time limit
export const totalPlayedStorageKey = 'earth.fm:audio-player:6e3e4e3e';

export const storageKeys = {
  scholarship: 'redirect_from_scholarship',
  giftCard: 'earth.fm:gift-card',
  redirectAfterSignIn: 'earth.fm:redirect-after-sign-in',
};

export const newsletterListIds = {
  newsletter: 6,
  appRelease: 19,
};

export const mobileDeepLinkConfig = {
  iosBundleId: process.env.GATSBY_IOS_BUNDLE_ID,
  androidPackageName: process.env.GATSBY_ANDROID_PACKAGE_NAME,
  authLinkDomain: process.env.GATSBY_AUTH_LINK_DOMAIN,
};

export const appStoreLinks = {
  ios: 'https://apps.apple.com/app/apple-store/id6464324601?pt=126546789&ct=web&mt=8',
  android:
    'https://play.google.com/store/apps/details?id=com.earthfm&referrer=utm_source%3Dweb26utm_campaign%3Dweb',
};
